import axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL

axios.defaults.headers.common = {
  'Api-key': process.env.VUE_APP_API_KEY,
}

export default async data => {
  try {
    return await axios.post(`${BASE_URL}contact`, data)
  } catch ({ response }) {
    return response
  }
}
